import { apiClient } from './apiClient';

export interface BirthInfo {
  year: number;
  month: number;
  day: number;
  hour: number;
  minute: number;
  gender: 'male' | 'female';
  calendar: 'solar' | 'lunar';
  location: string;
}

export interface ConsultationData {
  question: string;
  answer: string;
  consultationType?: 'general' | 'career' | 'love' | 'health' | 'wealth';
}

export interface ConsultationResponse {
  id: number;
  question: string;
  answer: string;
  consultationType: 'general' | 'career' | 'love' | 'health' | 'wealth';
  createdAt: string;
}

export interface UserProfile {
  id: number;
  email: string;
  displayName: string;
  birthDate?: string;
  birthTime?: string;
  birthLocation?: string;
  gender?: 'male' | 'female';
  calendar?: 'solar' | 'lunar';
  createdAt: string;
  updatedAt: string;
}

export class UserApiService {
  // 获取用户资料
  static async getUserProfile(): Promise<UserProfile> {
    const response = await apiClient.get('/user/profile');
    return response.data;
  }

  // 更新用户资料
  static async updateUserProfile(data: Partial<UserProfile>): Promise<UserProfile> {
    const response = await apiClient.put('/user/profile', data);
    return response.data;
  }

  // 获取用户出生信息
  static async getBirthInfo(): Promise<BirthInfo | null> {
    const response = await apiClient.get('/user/birth-info');
    return response.data;
  }

  // 保存出生信息并生成命盘
  static async saveBirthInfo(birthInfo: BirthInfo, astrolabeData: any): Promise<{ birthInfo: BirthInfo; astrolabe: any }> {
    const response = await apiClient.post('/user/birth-info', {
      ...birthInfo,
      astrolabeData
    });
    return response.data;
  }

  // 获取用户命盘数据
  static async getAstrolabe(): Promise<{ birthInfo: BirthInfo; astrolabe: any } | null> {
    const response = await apiClient.get('/user/astrolabe');
    return response.data;
  }

  // 获取咨询历史
  static async getConsultations(limit: number = 20, offset: number = 0): Promise<{
    consultations: ConsultationResponse[];
    total: number;
    limit: number;
    offset: number;
  }> {
    const response = await apiClient.get('/user/consultations', {
      params: { limit, offset }
    });
    return response.data;
  }

  // 保存咨询记录
  static async saveConsultation(data: ConsultationData): Promise<ConsultationResponse> {
    const response = await apiClient.post('/user/consultations', data);
    return response.data;
  }

  // 删除咨询记录
  static async deleteConsultation(id: number): Promise<{ success: boolean }> {
    const response = await apiClient.delete(`/user/consultations/${id}`);
    return response.data;
  }

  // 获取最近的咨询记录
  static async getRecentConsultations(limit: number = 5): Promise<ConsultationResponse[]> {
    const response = await apiClient.get('/user/consultations/recent', {
      params: { limit }
    });
    return response.data;
  }
}